<template>
  <section class="hero is-fullheight-with-navbar">
    <DetailEditLayout :name="view">
      <template v-slot:image>
        <ImageViewer
          v-if="imageInfo"
          ref="viewer"
          :source="iiifUrl"
          :width="imageInfo.width"
          :height="imageInfo.height"
          :xmlJson="xmlJson"
          :results="results"
        />
        <aside class="detail-image-controls-wrapper">
          <ImageControls @input="handleControlEvent" />
        </aside>
      </template>

      <template v-slot:content>
        <Content v-if="xmlJson" id="textEditor" :xmlJson="xmlJson" />
      </template>
    </DetailEditLayout>
  </section>
</template>
<style lang="scss">
// .detail-image-controls-wrapper {
//   position: absolute;
//   right: 1.25rem;
//   top: 1.25rem;
// }
</style>

<script>
import DetailEditLayout from "./DetailEditLayout.vue";
import Content from "./DetailContentEdit.vue";
import ImageViewer from "./DetailImageEditViewer.vue";
import ImageControls from "./DetailImageControls.vue";

import { parseJsonContent } from "../../utils/xml.js";
import imageMixin from "../../mixins/image.js";
import { getImageSize } from "../../utils/api.js";

import { mapState, mapGetters } from "vuex";

var WindowObjectReference; // global variable

export default {
  components: {
    DetailEditLayout,
    Content,
    ImageViewer,
    ImageControls,
  },
  props: {
    // iiifUrl: {
    //   type: String,
    //   required: true,
    // },
    // xmlJson: {
    //   type: Object,
    //   required: true,
    // },
  },
  mixins: [imageMixin],
  data() {
    return {
      imageInfo: null,
    };
  },
  computed: {
    ...mapState("detail", [
      // document
      "docId",
      "title",
      "colTitle",
      "pageNum",
      "maxPage",
      "isDocumentReady",
      "tsList",

      // page
      "image",
      "isPageReady",
      "isPageContentReady",
      // search
      "results",
      "view",
      "tagMode",
    ]),
    ...mapState("content", [
      "data",
      "selected",
      "highlighted",
      "fetchPageContent",
      "iiifUrl",
      "xmlJson",
    ]),
    ...mapGetters("detail", ["isLoading"]),
    source() {
      return this.getImageInfo(this.image.id);
    }
  },
    watch: {
      iiifUrl: {
      handler: async function (newValue, oldValue) {
        this.imageInfo= null
      const response = await fetch(newValue);
      const data = await response.json();
      this.imageInfo= data
     },
      deep: true,
    },
    },
  async mounted() {
    const response = await fetch(this.iiifUrl);
    const data = await response.json();
    this.imageInfo = data;
  },
  async destroyed() {
    // reset state
    this.$store.dispatch("content/reset");
  },
  methods: {
    async update() {
      await this.$store.dispatch("detail/fetch", this.$route.params);
    },
    handleControlEvent(event) {
      if (event.type.toLowerCase() === "zoom") {
        this.$refs.viewer.zoom(event.delta);
      }
      if (event.type.toLowerCase() === "home") {
        this.$refs.viewer.setHome();
      }
      if (event.type.toLowerCase() === "fit") {
        this.$refs.viewer.fitToWidth();
      }
    },
  },
};
</script>
